import { render, staticRenderFns } from "./DashboardFinanceiro.vue?vue&type=template&id=8c09ea00"
import script from "./DashboardFinanceiro.vue?vue&type=script&lang=js"
export * from "./DashboardFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports